<template>
  <div id="editar-edital">
    <b-overlay :show="loadEdital">
      <div class="d-flex justify-content-end mx-4 my-2">
        <span
          ><strong>{{ situacaoComputed }}</strong></span
        >
      </div>
      <b-card header-tag="header" class="m-3" no-body>
        <template #header>
          <header-sagres
            :titulo="tituloComputed"
            :botoes="botoesHeader"
            breakpoint="xl"
          />
        </template>
        <b-tabs card v-model="pageTab">
          <b-tab title="Dados Gerais" id="dados-gerais">
            <AbaCadastroConcurso
              :idEdital="Number(idEdital)"
              @atualizar-cargos="atualizarAbas"
              ref="abaCadastroConcurso"
            />
          </b-tab>

          <b-tab title="Anexo" id="anexos">
            <AbaAnexoConcurso
              :idEdital="Number(idEdital)"
              :idTipoEdital="edital.IdTipoEdital"
              :contador="contador"
              @atualizarEdital="atualizarComponentes"
              ref="abaAnexoConcurso"
            />
          </b-tab>

          <b-tab
            :title="edital.IdTipoEdital === 3 ? 'Funções' : 'Cargos'"
            id="cargos"
          >
            <AbaCargosConcurso
              :idEdital="Number(idEdital)"
              @atualizarEdital="atualizarComponentes"
              ref="abaCargosConcurso"
            />
          </b-tab>

          <b-tab
            title="Homologação"
            id="homologacao"
            v-if="edital.IdSituacao === 4 || edital.IdSituacao === 2"
            class="tab-responsiva"
          >
            <AbaHomologarEdital
              :idEdital="Number(idEdital)"
              :idTipoEdital="edital.IdTipoEdital"
              :contador="contador"
              :dataHomologacao="
                edital.DtHomologacao ? String(edital.DtHomologacao) : undefined
              "
              @atualizarEdital="atualizarComponentes"
              ref="abaHomologarEdital"
            />
          </b-tab>

          <b-tab
            title="Publicidade"
            id="ato-publicidade"
            v-if="edital.IdSituacao === 2"
          >
            <AbaAtoPublicidade
              :idEdital="Number(idEdital)"
              :idTipoEdital="edital.IdTipoEdital"
              :contador="contador"
              @atualizarEdital="atualizarComponentes"
              ref="abaAtoPublicidade"
            />
          </b-tab>

          <b-tab
            title="Classificados"
            id="classificados"
            v-if="edital.IdSituacao === 2"
          >
            <AbaClassificadosConcurso
              :idEdital="Number(idEdital)"
              ref="abaClassificadosConcurso"
            />
          </b-tab>
        </b-tabs>
      </b-card>
      <ModalPendencias
        v-if="openModal"
        :edital="edital"
        @close="closeModalPendencias"
      />
      <ModalPendenciasHomologacao
        v-if="openModalHml"
        :edital="edital"
        @close="closeModalPendenciasHml"
      />
    </b-overlay>
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { BotaoSagres } from "@/types/botao-sagres";
import { Component, Vue } from "vue-property-decorator";
import concursoService from "@/services/atos-pessoal/concursoService";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import AbaCadastroConcurso from "@/components/atos-pessoal/concursos/AbaCadastrarConcurso.vue";
import AbaAnexoConcurso from "@/components/atos-pessoal/concursos/AbaAnexoConcurso.vue";
import AbaCargosConcurso from "@/components/atos-pessoal/concursos/AbaCargosConcurso.vue";
import AbaClassificadosConcurso from "@/components/atos-pessoal/concursos/AbaClassificadosConcurso.vue";
import { EditalConcurso } from "@/types/atos-pessoal/concursos/edital";
import ModalPendencias from "@/components/atos-pessoal/concursos/ModalPendencias.vue";
import ModalPendenciasHomologacao from "@/components/atos-pessoal/concursos/ModalPendenciasHomologacao.vue";
import AbaHomologarEdital from "@/components/atos-pessoal/concursos/AbaHomologarEdital.vue";
import AbaAtoPublicidade from "@/components/atos-pessoal/concursos/AbaAtoPublicidade.vue";

const CompProps = Vue.extend({
  name: "EditarEdital",
  props: {
    idEdital: {
      type: String,
      required: true,
    },
  },
  components: {
    HeaderSagres,
    AbaCadastroConcurso,
    AbaAnexoConcurso,
    AbaCargosConcurso,
    AbaClassificadosConcurso,
    ModalPendencias,
    ModalPendenciasHomologacao,
    AbaHomologarEdital,
    AbaAtoPublicidade,
  },
});

@Component
export default class EditarEdital extends mixins(UtilsTS, CompProps) {
  botoesHeader: BotaoSagres[] = [
    {
      id: -1,
      texto: "Voltar",
      icone: "arrow-left",
    },
  ];

  edital = new EditalConcurso();
  openModal = false;
  openModalHml = false;
  contador = 0;
  pageTab = 0;

  loadEdital = false;

  get tituloComputed() {
    return `Editar ${
      this.edital?.IdTipoEditalNavigation?.DsTipoEdital || "Edital"
    } ${this.edital.NrEdital}/${this.edital.AnoEdital}`;
  }

  get situacaoComputed() {
    switch (this.edital.IdSituacao) {
      case 1:
        return "Situação: Em Cadastramento";
      case 2:
        return "Situação: Homologado";
      case 3:
        return "Situação: Cancelado";
      case 4:
        return "Situação: Cadastrado";
      default:
        return "";
    }
  }

  async created() {
    await this.carregarEdital(Number(this.idEdital));
    this.pageTab = Number(this.$route.params.pageTab);
  }

  async atualizarAbas() {
    // Refresh centralizado: cada aba recarrega seu proprio estado quando existir em tela.
    // Algumas abas ficam fora do DOM por v-if, por isso os refs podem ser undefined.
    const abaCadastro = this.$refs.abaCadastroConcurso as
      | InstanceType<typeof AbaCadastroConcurso>
      | undefined;
    const abaAnexo = this.$refs.abaAnexoConcurso as
      | InstanceType<typeof AbaAnexoConcurso>
      | undefined;
    const abaCargos = this.$refs.abaCargosConcurso as
      | InstanceType<typeof AbaCargosConcurso>
      | undefined;
    const abaClassificados = this.$refs.abaClassificadosConcurso as
      | InstanceType<typeof AbaClassificadosConcurso>
      | undefined;
    const abaHomologar = this.$refs.abaHomologarEdital as
      | InstanceType<typeof AbaHomologarEdital>
      | undefined;
    const abaAtoPublicidade = this.$refs.abaAtoPublicidade as
      | InstanceType<typeof AbaAtoPublicidade>
      | undefined;

    const atualizacoes: Promise<void>[] = [];

    // Mantemos as cargas em paralelo para reduzir tempo de espera apos salvar/alterar.
    if (abaCadastro) {
      atualizacoes.push(
        (async () => {
          await abaCadastro.loadData();
        })()
      );
    }

    if (abaAnexo) {
      atualizacoes.push(
        (async () => {
          await abaAnexo.carregarAnexos();
          await abaAnexo.carregarTiposArquivo();
        })()
      );
    }

    if (abaCargos) {
      atualizacoes.push(
        (async () => {
          await abaCargos.getConcursoById();
          await abaCargos.carregarCargos();
          await abaCargos.carregarCargosEdital();
        })()
      );
    }

    if (abaClassificados) {
      atualizacoes.push(
        (async () => {
          await abaClassificados.getConcursoById();
          await abaClassificados.carregarCargos();
          await abaClassificados.carregarTiposClassificado();
          await abaClassificados.carregarClassificados();
        })()
      );
    }

    if (abaHomologar) {
      atualizacoes.push(
        (async () => {
          await abaHomologar.listarTiposAnexo();
          await abaHomologar.listarAnexos();
        })()
      );
    }

    if (abaAtoPublicidade) {
      atualizacoes.push(
        (async () => {
          await abaAtoPublicidade.carregarAnexos();
          await abaAtoPublicidade.carregarTiposArquivo();
        })()
      );
    }

    // Promise.all garante que todas as abas terminem o refresh antes de seguir.
    await Promise.all(atualizacoes);
  }

  async atualizarComponentes() {
    // Primeiro atualiza o resumo do edital no pai, depois sincroniza as abas dependentes.
    this.contador += 1;
    await this.carregarEdital(Number(this.idEdital));
    await this.atualizarAbas();
  }

  async carregarEdital(idEdital: number) {
    try {
      this.loadEdital = true;
      const response = await concursoService.getConcursoById(idEdital);
      this.edital = new EditalConcurso(response);
      this.botoesHeader = [this.botoesHeader[0]];
      if (this.edital.IdSituacao === 1)
        this.botoesHeader.push({
          id: 1,
          texto: "Pendências Cadastro",
          icone: "clipboard-check",
          acao: this.openModalPendencias,
        });
      else if (this.edital.IdSituacao === 4)
        this.botoesHeader.push({
          id: 2,
          texto: "Pendências Homologação",
          icone: "clipboard-check",
          acao: this.openModalPendenciasHml,
        });
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.loadEdital = false;
    }
  }

  openModalPendencias() {
    this.openModal = true;
  }
  closeModalPendencias() {
    this.openModal = false;
  }

  openModalPendenciasHml() {
    this.openModalHml = true;
  }
  closeModalPendenciasHml() {
    this.openModalHml = false;
  }
}
</script>

<style scoped>
@media screen and (max-width: 768px) {
  div.tab-responsiva {
    padding: 0px;
  }
}
</style>
